var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightLowerArm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 650 1600",
    width: 650,
    height: 1600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fbc3a4}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m154.6 621c8.3 66.8 120.7 525 100 734.4 34.2 110.4 77.8 203.7 123.4 201.7 90.7-4.2 138.9-376.3 137.8-513.2-4.6-600.7 42.6-768.1-48.2-764-90.1 4.1-445.7-722-313 341.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightLowerArm);
export default __webpack_public_path__ + "static/media/right_lower_arm.83e0606b1066faefd9f82c1fe5aabc1c.svg";
export { ForwardRef as ReactComponent };